import Breadcrumb from 'components/Breadcrumb';
import React, { Component } from 'react';
import Icon from '../../../icons/Icon';
import WatchlistListComponent from './WatchlistListComponent';
import { FormicaProps, withFormica } from '../../../helpers/withFormica';
import { WatchlistEntityRequest, WatchlistGeneralRequest, WatchlistIndividualRequest } from '../../../domain/watchlist/WatchlistDomains';
import { WatchlistType } from '../../../constant/Constants';
import moment from 'moment/moment';
import NavigationUtil from '../../../util/NavigationUtil';
import WatchlistSearchCriteriaModalComponent from '../detail/modal/WatchlistSearchCriteriaModalComponent';
import LanguageUtil from '../../../util/LanguageUtil';
import MessageUtil from '../../../util/MessageUtil';
import WatchlistUtil from '../../../util/WatchlistUtil';
import { query, repository, subscribe } from '@trlogic/client-js';
import { InstanceContainer } from '../../../config/binding/InstanceBinding';
import Injectables from '../../../constant/Injectables';
import CollectionNames from '../../../constant/CollectionNames';
import CustomLoading from '../../custom/CustomLoading';
import { MatchManyLog, WatchlistHistoryView } from '../../../domain/watchlist/WatchlistHistoryDomains';
import QueryBuilder = query.QueryBuilder;
import eq = query.eq;

class WatchlistTabComponent extends Component<Props, State> {
  public state: State = new State();

  private repository: repository.ReadOnlyQueryableRepository = InstanceContainer.get(Injectables.REPOSITORY);
  private historySubscription: subscribe.Subscription | undefined;
  private computation: subscribe.Computation | undefined;

  public render() {
    const { router } = this.props;
    const { request, date, searchCriteriaVisible, type } = this.state;
    return (
      <div className='w-full h-full flex flex-col overflow-y-hidden'>
        <Breadcrumb />
        <div className={'p-5'}>
          <div className={'flex'}>
            <span
              key={'icon'}
              className='w-[60px] h-[60px] min-h-[60px] min-w-[60px] 2xl:w-[80px] 2xl:h-[80px] 2xl:min-h-[80px] 2xl:min-w-[80px] flex justify-center items-center rounded-[50%] bg-[#EFF2FE] mr-1'
            >
              {type == 'General' ? (
                <img src={'/icons/general.svg'} alt='individual' />
              ) : type == 'Individual' ? (
                <img src={'/icons/individual.svg'} alt='individual' />
              ) : type == 'Entity' ? (
                <img src={'/icons/entity.svg'} alt='entity' />
              ) : (
                <Icon icon={'configuration'} className={'text-f-purple'} size={32} />
              )}
            </span>
            <div className={'flex flex-col justify-center pl-3'}>
              <span className={'text-[24px] 2xl:text-4xl font-normal'}>
                {request?.name || LanguageUtil.get({ id: 'common.label.watchlistTable', defaultMessage: 'Watchlist Table' })}
              </span>
              <div className={'flex items-center gap-x-2'}>
                <span
                  className={`flex text-xs shrink-0 2xl:text-md h-full justify-center items-center px-[8px] py-[3px] rounded-[50px] bg-[#F6F6F9] text-[#4F4F4F]`}
                >
                  {date}
                </span>
                <div className={'flex gap-x-1 cursor-pointer'} onClick={() => this.setState({ searchCriteriaVisible: true })}>
                  <span className={'text-[14px] underline text-normal text-[#458EF7]'}>
                    {LanguageUtil.get({ id: 'common.label.searchCriteria', defaultMessage: 'Search Criteria' })}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={'px-5 h-full w-full flex flex-col min-h-0'}>
          <div className={'text-f-black-2 text-[13px] flex items-center gap-x-2.5'}>
            <Icon icon={'feed'} size={12} color={'#728EFF'} />
            <span>
              {' '}
              {LanguageUtil.get({
                id: 'pages.watchlist.criteriaDescription',
                defaultMessage: 'Below are listed the results of the search made with the criteria',
              })}{' '}
              "{this.getRequestValues()}"
            </span>
          </div>
          <div className={'text-f-black-2 text-[13px] flex items-center gap-x-2.5'}>
            <Icon icon={'brand_awareness'} size={12} color={'#728EFF'} />
            <span>
              {LanguageUtil.get({ id: 'pages.watchlist.click' })}{' '}
              <span className={'underline text-[#458EF7] cursor-pointer'} onClick={this.onClickNews}>
                {LanguageUtil.get({ id: 'pages.watchlist.news', defaultMessage: 'news' })}{' '}
              </span>{' '}
              {LanguageUtil.get({
                id: 'pages.watchlist.newsDescription2',
                defaultMessage: ' button to see the results found on the internet according to the search results.',
              })}
            </span>
          </div>
          <div className={'text-f-black-2 text-[13px] flex items-center gap-x-2.5'}>
            <Icon icon={'captive_portal'} size={12} color={'#728EFF'} />
            <span>
              {LanguageUtil.get({ id: 'pages.watchlist.click' })}{' '}
              <span className={'underline text-[#458EF7] cursor-pointer'} onClick={this.onClickSocialMedia}>
                {LanguageUtil.get({ id: 'pages.watchlist.socialMedia', defaultMessage: 'Social Media' })}{' '}
              </span>{' '}
              {LanguageUtil.get({ id: 'pages.watchlist.socialMediaDescription', defaultMessage: 'Social Media Description' })}{' '}
            </span>
          </div>
          {router.params.logId == undefined && (
            <div className={'text-f-black-2 text-[13px] flex items-center gap-x-2.5'}>
              <Icon icon={'safe-list'} size={12} color={'#728EFF'} />
              <span>
                {LanguageUtil.get({
                  id: 'pages.watchlist.safeListDescriptionPrefix',
                  defaultMessage: 'Click to view the requests you have added to the',
                })}{' '}
                <span className={'underline text-[#458EF7] cursor-pointer'} onClick={this.onClickSafeList}>
                  {LanguageUtil.get({ id: 'pages.watchlist.safeListLink', defaultMessage: 'safe list' })}
                </span>
                {LanguageUtil.get({ id: 'pages.watchlist.safeListDescriptionSuffix', defaultMessage: '.' })}
              </span>
            </div>
          )}
          <div className={'text-f-black-2 text-[13px] flex items-center gap-x-2.5'}>
            <Icon icon={'ballot'} size={12} color={'#728EFF'} />
            <span>
              {LanguageUtil.get({
                id: 'pages.watchlist.ballot',
                defaultMessage: 'You can review the list of people who meet the search criteria in the table below.',
              })}
            </span>
          </div>
          <div className={'pt-9 flex-1 min-h-0 w-full overflow-visible'}>{this.renderList()}</div>
        </div>
        <WatchlistSearchCriteriaModalComponent
          visible={searchCriteriaVisible}
          request={request}
          onClose={() => this.setState({ searchCriteriaVisible: false })}
        />
      </div>
    );
  }

  public async componentDidMount() {
    const { router } = this.props;
    if (router.params.logId != undefined) {
      this.startHistoryTracker();
      return;
    }
    const previousSearchParams = new URLSearchParams(router.params.id);
    const type: string | null = previousSearchParams.get('type');
    const request = WatchlistUtil.buildRequestFromSearchParams(previousSearchParams);
    this.setState({
      request,
      type: type as WatchlistType,
      date: moment().format('DD/MM/yyyy HH:mm').valueOf(),
    });
  }

  public async componentWillUnmount() {
    await this.historySubscription?.stop();
    this.computation?.stop();
  }

  private renderList = () => {
    const { router } = this.props;
    const { history, historyLoading } = this.state;
    if (router.params.logId == undefined) {
      return <WatchlistListComponent />;
    }
    if (historyLoading) {
      return <CustomLoading />;
    }
    return history ? <WatchlistListComponent history={history} /> : null;
  };

  private getHistoryQuery = (): query.Query => {
    const { router } = this.props;
    return QueryBuilder.select().from(CollectionNames.MATCH_MANY_LOGS).where(eq('id', router.params.logId)).build();
  };

  private startHistoryTracker = () => {
    this.historySubscription = subscribe.Formica.subscribe(CollectionNames.MATCH_MANY_LOGS, this.getHistoryQuery());
    this.computation = subscribe.Tracker.autorun(this.historyTracker, [this.historySubscription]);
  };

  private historyTracker = async () => {
    if (!this.historySubscription?.ready() || !this.state.historyLoading) {
      return;
    }
    const log: MatchManyLog | undefined = await this.repository.find(this.getHistoryQuery());
    const history = log ? WatchlistUtil.buildHistoryView(log) : undefined;
    if (history == undefined) {
      MessageUtil.error({
        summary: LanguageUtil.get({ id: 'pages.watchlist.title', defaultMessage: 'Watchlist' }),
        detail: LanguageUtil.get({ id: 'common.label.dataNotFound', defaultMessage: 'Data Not found' }),
      });
      this.setState({ historyLoading: false });
      return;
    }
    this.setState({
      history,
      historyLoading: false,
      request: history.request,
      type: history.type,
      date: moment(history.createdAt).format('DD/MM/yyyy HH:mm').valueOf(),
    });
  };

  private onClickNews = () => {
    const urlParams = this.setUrlCalculate();
    window.open(`/${NavigationUtil.getTenant()}/watchlist/list/news/${urlParams.toString()}`, '_blank', 'noopener noreferrer');
  };

  private onClickSocialMedia = () => {
    const urlParams = this.setUrlCalculate();
    window.open(`/${NavigationUtil.getTenant()}/watchlist/list/social-media/${urlParams.toString()}`, '_blank', 'noopener noreferrer');
  };

  private onClickSafeList = () => {
    const { router } = this.props;
    const { request } = this.state;
    const referenceId = request?.referenceId;
    if (referenceId == undefined || referenceId == null || referenceId.trim().length == 0) {
      MessageUtil.error({
        summary: LanguageUtil.get({ id: 'pages.watchlist.title', defaultMessage: 'Watchlist' }),
        detail: LanguageUtil.get({
          id: 'pages.watchlist.safeListReferenceIdRequired',
          defaultMessage: 'Reference ID is required for Safe List operations!',
        }),
      });
      return;
    }
    window.open(`/${NavigationUtil.getTenant()}/watchlist/list/safe-list/${router.params.id}`, '_blank', 'noopener noreferrer');
  };

  private setUrlCalculate = () => {
    const { request } = this.state;
    const urlParams = new URLSearchParams();
    urlParams.set('email', request?.email || '');
    urlParams.set('phone', request?.phone || '');
    urlParams.set('name', request?.name || '');
    return urlParams;
  };

  private getRequestValues = () => {
    const { request } = this.state;
    if (request == undefined) return;
    let stringifyRequest = '';
    Object.entries(request).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        if (typeof value === 'string' || typeof value === 'number') {
          stringifyRequest += `${key}: ${value}, `;
        }
      }
    });
    stringifyRequest = stringifyRequest.slice(0, -2);
    return stringifyRequest;
  };
}

class State {
  searchCriteriaVisible: boolean = false;
  request: WatchlistIndividualRequest | WatchlistEntityRequest | WatchlistGeneralRequest | undefined;
  type: WatchlistType = 'General';
  date: string | undefined;
  history: WatchlistHistoryView | undefined;
  historyLoading: boolean = true;
}

interface Props extends FormicaProps {}

export default withFormica(WatchlistTabComponent);
